export const PHRASE_SIZE = 6;
export const BASE_URL = import.meta.env.VITE_SEND_CLIENT_URL;
